import { SVGProps } from 'react';
import { ReactComponent as aku } from './assets/aku.svg';
import { ReactComponent as azr } from './assets/azr.svg';
import { ReactComponent as bsu } from './assets/bsu.svg';
import { ReactComponent as gln } from './assets/gln.svg';
import { ReactComponent as hnr } from './assets/hnr.svg';
import { ReactComponent as knt } from './assets/knt.svg';
import { ReactComponent as urm } from './assets/urm.svg';
import { ReactComponent as ust } from './assets/ust.svg';
import { ReactComponent as smn } from './assets/smn.svg';
import { ReactComponent as teh } from './assets/teh.svg';
import { ReactComponent as sbu } from './assets/sbu.svg';
import { ReactComponent as tbz } from './assets/tbz.svg';
import { ReactComponent as rja } from './assets/rja.svg';
import { ReactComponent as shf } from './assets/shf.svg';
import { ReactComponent as kut } from './assets/kut.svg';
import { ReactComponent as jft } from './assets/jft.svg';
import { ReactComponent as qhu } from './assets/qhu.svg';
import { ReactComponent as tvu } from './assets/tvu.svg';
import { ReactComponent as azad } from './assets/azad.svg';
import { ReactComponent as amfm } from './assets/amfm.svg';
import { ReactComponent as ihu } from './assets/ihu.svg';
import { ReactComponent as ikiu } from './assets/ikiu.svg';

const images = {
  aku,
  azr,
  bsu,
  gln,
  hnr,
  knt,
  urm,
  ust,
  smn,
  teh,
  sbu,
  tbz,
  tmi: tbz,
  tma: tbz,
  tah: tbz,
  rja,
  shf,
  kut,
  jft,
  qhu,
  qht: qhu,
  wia: azad,
  tvu,
  amfm,
  ihu,
  ikiu
};

export interface UniversityLogoProps extends SVGProps<SVGElement> {
  uniKey: string;
}

export function UniversityLogo({ uniKey, style, ...rest }: UniversityLogoProps) {
  const Image = images[(typeof uniKey !== 'string' ? '' : uniKey).toLowerCase()];
  if (!Image) {
    return <></>;
  }
  return (<Image style={{ height: '60px', fill: '#4C8251', ...style }} {...rest} />);
}

export default UniversityLogo;
